(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('soffio-cart-social-proof')) {
  class SoffioCartSocialProof extends HTMLElement {
    constructor() {
      super();
      this.handleCartChange = this.handleCartChange.bind(this);
    }

    connectedCallback() {
      document.addEventListener('theme:cart:change', this.handleCartChange);
    }

    disconnectedCallback() {
      document.removeEventListener('theme:cart:change', this.handleCartChange);
    }

    handleCartChange(event) {
      if (!event.detail || event.detail.cartCount === undefined) return;

      const count = Number(event.detail.cartCount);
      if (!Number.isFinite(count) || count < 0) return;

      this.hidden = count === 0;

      if (this.hidden) {
        const details = this.querySelector('details');
        if (details) details.open = false;
      }
    }
  }

  customElements.define('soffio-cart-social-proof', SoffioCartSocialProof);
}
  } catch(e) { console.error(e); }
})();

})();
